import React from 'react';

const Footer = () => {
    return (
        <div className='bg-black py-5'>
        <div className='text-center text-white'>
            <p>© Copyright 2022. All Rights Reserved.</p>
        </div>
        </div>
    );
};

export default Footer;
